module.exports = __webpack_public_path__ + "static/img/TF.2fd6d4ef.svg";